/**
 * PhilConsentModal.js
 * Modal for consent-to-save when ending a Phil session
 *
 * Shows on any exit scenario:
 * - Click "End Conversation" button
 * - Navigate to another feature
 * - Close browser tab (via beforeunload)
 *
 * User must explicitly choose to keep or discard the conversation.
 * No dismiss X - must make a choice.
 */

import React, { useRef } from 'react';
import useFocusTrap from '../../hooks/useFocusTrap';
import './PhilConsentModal.css';

const PhilConsentModal = ({ isOpen, onKeep, onDiscard, isLoading = false }) => {
  const modalRef = useRef(null);

  // =========================================
  // Focus Trap
  // =========================================
  useFocusTrap(modalRef, isOpen);

  if (!isOpen) return null;

  return (
    <div className="phil-consent-overlay">
      <div
        className="phil-consent-modal"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="phil-consent-question"
      >
        <div className="phil-consent-icon">
          <span>?</span>
        </div>

        <p id="phil-consent-question" className="phil-consent-question">
          Would you like Phil to be able to remember this conversation?
        </p>

        <div className="phil-consent-actions">
          <button
            className="phil-consent-btn phil-consent-keep"
            onClick={(e) => { e.stopPropagation(); onKeep(); }}
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Remember this'}
          </button>
          <button
            className="phil-consent-btn phil-consent-discard"
            onClick={(e) => { e.stopPropagation(); onDiscard(); }}
          >
            Let it go
          </button>
        </div>

        <p className="phil-consent-note">
          Remembered conversations can be revisited in future sessions.
        </p>
      </div>
    </div>
  );
};

export default PhilConsentModal;
